import styled from 'styled-components';

export const StyledChequeForm = styled.div`
  .modal-title {
    font-size: 22px;
    p {
      font-weight: normal;
      font-size: 18px;
    }
  }
  .js-bank-code input {
    height: auto;
  }
  
  .DayPickerInput {
    width: 100%;
  }
  
  .add-rows-field {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 200px;
    #addBtn-new {
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }
  }
  .form-group {
    position: relative;
    label.error {
      position: absolute;
      top: 100%;
      right: 40px;
    }
  }
  .error {
    &.form-control {
      border-color: red !important;
    }
    .DayPickerInput {
      color: #000;
      &::after {
        border-color: red;
      }
      input {
        border-color: red;
      }
    }
  }

  .js-cheque-form {
    .form-group {
      margin: 0 !important;
      min-width: 160px;
      width: 100%;

      label {
        text-align: start !important;
      }
    }

    .row-cheque-container {
      display: flex;
      border-bottom: 1px solid var(--bllink-blue);
      padding-bottom: 30px;
      margin-bottom: 30px;
      align-items: center;

      .input-container {
        input {
          background: transparent;
          border: 1px solid var(--bllink-blue);
          border-radius: 50px;
          box-sizing: border-box;
          height: 52px;
          position: relative;
        }
      }
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(-2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media screen and (max-width: 768px) {
    .js-cheque-form {
      .row-cheque-container {
        flex-direction: column;
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
        gap: 20px;
      }

      .row-cheque-container.margin-bottom {
        margin-bottom: 20px;
      }

      .row {
        gap: 20px;
        margin-top: 30px;
      }
    }
  }
`;